export const CURRENCY_RATES_LOCAL_STORAGE_KEY = 'currencyRates';
export const CURRENT_CURRENCY_TYPE_LOCAL_STORAGE_KEY = 'currentCurrencyType';
